import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=1fab6fa1"
import script from "./temp.vue?vue&type=script&lang=js"
export * from "./temp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9aa694ea4cedabb1298fdccf3864a561/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports